import CastForEducationIcon from "@material-ui/icons/CastForEducation";
import AcademicLevelList from "./AcademicLevelList";

export default {
  list: AcademicLevelList,
  icon: CastForEducationIcon,
};
